import React from "react";
import { CustomInput, Button } from "reactstrap";

const statusOptions = ["All", "Draft", "ReadyToPublish", "Published"];
const sourceOptions = [
    "All",
    "Rooms",
    "Products",
    "FAQ",
    "Web Widget Menus",
    "Compendium",
    "Forms",
    "Documents",
    "Knowledge Hub",
];

function SideMenuBar({ selectedSource,
    // selectedStatus,
    onSourceChange,
    // onStatusChange,
    contextData,
    itemCountsData,
    publishContentUrl }) {

    // const getStatusCount = (status) => {
    //     if (status === "All") return contextData.length;
    //     return contextData.filter((item) => item.status === status).length;
    // };

    const sourceCountMap = {
        "Rooms": itemCountsData?.roomTypesCount ?? 0,
        "Products": itemCountsData?.productsAndServicesCount ?? 0,
        "FAQ": itemCountsData?.faqCount ?? 0,
        "Web Widget Menus": itemCountsData?.wedWidgetCount ?? 0,
        "Compendium": itemCountsData?.compendiumCount ?? 0,
        "Forms": itemCountsData?.formsCount ?? 0,
        "Documents": itemCountsData?.documentCount ?? 0,
        "Knowledge Hub": itemCountsData?.knowledgehubCount ?? 0,
    };

    const totalSourceCount = Object.values(sourceCountMap)
        .reduce((sum, val) => sum + val, 0);

    const getSourceCount = (source) => {
        if (source === "All") return totalSourceCount;
        return sourceCountMap[source] ?? 0;
    };
    return (
        <div className="fixed-side-menu ">
            {/* <h6 className="mb-3">Status</h6>
            {statusOptions.map((status) => (
                <div key={status} className="d-flex justify-content-between align-items-center mb-2">
                    <CustomInput
                        type="radio"
                        id={`status-${status}`}
                        name="status"
                        label={status === "ReadyToPublish" ? "Ready to Publish" : status}
                        checked={selectedStatus === status}
                        onChange={() => onStatusChange(status)}
                    />
                    <span>{getStatusCount(status)}</span>
                </div>
            ))} */}

            <h6 className="mb-3 mt-4">Source</h6>
            {sourceOptions.map((source) => (
                <div key={source} className="d-flex justify-content-between align-items-center mb-2">
                    <CustomInput
                        type="radio"
                        id={`source-${source}`}
                        name="source"
                        label={source}
                        checked={selectedSource === source}
                        onChange={() => onSourceChange(source)}
                    />
                    <span>{getSourceCount(source)}</span>
                </div>
            ))}

            {publishContentUrl && (
                <div className="mt-2  ml-2">
                    <a
                        href={publishContentUrl}
                        rel="noopener noreferrer"
                        target="_blank"
                        className="publish-btn"
                    >

                        Download Content

                    </a>
                </div>
            )
            }
        </div >
    );
}

export default SideMenuBar;